import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

import {
    GetConnectionReportsAsyncPayload,
    GetConnectionSourceMappingAsyncPayload,
} from "./leadReports.types";

export const getConnectionReportsAsync = createAsyncThunk(
    "leadConnection/getConnectionReports",
    async (payload: GetConnectionReportsAsyncPayload) => {
        const { id, ...params } = payload;
        const response = await axios.get(
            `${baseURL}/api/lead/connection-stats-reports/${id}`,
            RequestConfig({
                params,
            }),
        );
        return response.data?.data;
    },
);

export const getConnectionSourceMappingAsync = createAsyncThunk(
    "leadConnection/getConnectionSourceMapping",
    async (payload: GetConnectionSourceMappingAsyncPayload) => {
        const { id } = payload;
        const response = await axios.get(
            `${baseURL}/api/lead/connection-source-mapping/${id}`,
            RequestConfig({}),
        );
        return response.data?.data;
    },
);
